<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      tableCardTitle="FX LIST"
    />
  </div>
</template>

<script>
import { getTableData } from './api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Currency',
        type: 'input',
        key: 'currencyName',
      },
    ]
    const tableModel = [
      {
        label: 'Currency Name',
        prop: 'currencyName',
      },
      {
        label: 'Currency',
        prop: 'currency',
      },
      {
        label: 'FX Rate',
        prop: 'rate',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
    ]
    return {
      tableModel,
      searchModel,
      tableData: [],
      pages: {},
      form: {},
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
  },
}
</script>
